import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo, useCallback } from 'react';
import ToolTip from './ToolTip/ToolTip';
const styles = css `
  background-color: #f5f5f5;
  border: none;
  border-radius: 5px;
  padding: 5px;

  &:disabled {
    opacity: 0.3;
  }

  &:not([disabled]) {
    &:hover {
      background-color: lightgray !important;
      color: black !important;
    }

    &.toggle-active {
      background-color: gray;
      color: white;
    }
  }
`;
function ActiveButton({ children, style = {}, onClick = () => null, popupTitle = '', popupPlacement = 'right', disabled = false, className = '', value, }) {
    const toggleHandler = useCallback(() => {
        onClick(!value);
    }, [onClick, value]);
    return (_jsx(ToolTip, { title: popupTitle, popupPlacement: popupPlacement, children: _jsx("button", { disabled: disabled, css: styles, style: style, className: (value ? 'toggle toggle-active ' : 'toggle ') + className, type: "button", onClick: toggleHandler, children: children }) }));
}
export default memo(ActiveButton);
